import { Text, View } from "@react-pdf/renderer";
import { Checklist } from "models/Checklist";
import PageLayout from "../components/PageLayout";
import SectionHeader from "../components/SectionHeader";
import ImagesSection from "../components/ImagesSection";
import { MediaEntity } from "models/MediaEntity";
import ProductsSection from "../components/ProductsSection";
import { orderSerialToProduct, serialEntityToProduct } from "utilities/serialEntityToOrderSerial";
import { Product } from "models/Product";
import CheckIcon from "../graphics/CheckIcon";
import { color } from "../styles";
import Header from "../components/Header";
import PageContent from "../components/PageContent";
import { useLocalization } from "../localization/LocalizationContext";

type ChecklistPageProps = {
  checklist: Checklist;
  images: MediaEntity[];
};

const ChecklistPage: React.FC<ChecklistPageProps> = ({ checklist, images }) => {
  const { strings } = useLocalization();
  const t = strings.checklistPage;

  const allProducts: Product[] = [
    ...checklist.installedProducts.map((p) => orderSerialToProduct(p)),
    ...checklist.serialEntities.map((s) => serialEntityToProduct(s, checklist)),
  ];

  return (
    <PageLayout>
      <Header title={checklist.roomName} />

      <PageContent style={{ paddingTop: 20 }}>
        {(checklist.functionCheck || checklist.documentationDone) && (
          <View>
            <SectionHeader>
              <Text>{t.selfInspection}</Text>
            </SectionHeader>

            <View
              style={{
                paddingVertical: 15,
                paddingHorizontal: 20,
                gap: 10,
                backgroundColor: color.lightGrey,
              }}
            >
              {checklist.functionCheck && (
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 5,
                    fontSize: 12,
                  }}
                >
                  <CheckIcon width={18} height={16} />

                  <Text>{t.functionCheckDone}</Text>
                </View>
              )}

              {checklist.documentationDone && (
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 5,
                    fontSize: 12,
                  }}
                >
                  <CheckIcon width={18} height={16} />

                  <Text>{t.documentationDone}</Text>
                </View>
              )}
            </View>
          </View>
        )}

        {allProducts.length > 0 && <ProductsSection products={allProducts} />}

        <ImagesSection images={images} />
      </PageContent>
    </PageLayout>
  );
};

export default ChecklistPage;
